import { gql } from "@apollo/client"

export const ALL_TOURNAMENT_TYPES = gql`
  query allTournamentTypes {
    allTournamentTypes(paginate: 99, orderBy: sortOrder_ASC) {
      id
      name
      description
      private
      status
      minPlayers
      urlImage
      urlImage2
      urlImage3
      urlImage4
      maxTopPlayers
      multiplier
      winnerPoints
      loserPoints
      drawPoints
      socialRequired
      urlUpdate
      storeTournaments
      canBeDouble
      totalTournaments
    }
  }
`
